import { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import styles from './Modal.module.css';

const Modal = ({ isOpen, onClose, selectedImage }) => {
  useEffect(() => {
    const handleKeyPress = (event) => {
      if (event.key === 'Escape' && isOpen) {
        onClose();
      }
    };

    const handleClickOutside = (event) => {
      if (isOpen && event.target.classList.contains(styles.modal)) {
        onClose();
      }
    };

    // console.log('selectedImage', selectedImage);

    window.addEventListener('keydown', handleKeyPress);
    window.addEventListener('click', handleClickOutside);

    return () => {
      window.removeEventListener('keydown', handleKeyPress);
      window.removeEventListener('click', handleClickOutside);
    };
  }, [isOpen, onClose]);

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5 }}
          exit={{ opacity: 0 }}
          className={`${styles.modal} ${isOpen ? styles.show : ''}`}
        >
          <motion.div
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2, duration: 0.5 }}
            exit={{ opacity: 0, y: -20 }}
            className={styles.modalContent}
          >
            <div className={styles.modalImgBox}>
              <span className={styles.close} onClick={onClose}>
                &times;
              </span>
              <img
                className={styles.modalImg}
                src={selectedImage.link}
                alt='Modal'
                border='0'
              />
            </div>
            <motion.div
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.4, duration: 0.5 }}
              exit={{ opacity: 0, y: 10 }}
              className={styles.modalImgDescriptionBox}
            >
              {/* <h2>Picture's name: Eleganto</h2> */}
              <p>Year: {selectedImage.year}</p>
              {/* <p>type of paint: acrylic, watercolour, etc.</p> */}
              <p>{selectedImage.size}</p>
              {/* <p>90 x 60 cm</p> */}
              <p>
                <b>{selectedImage.status}</b>
                {/* <b>For Sale or Sold</b> */}
              </p>
              {/* <p>picture description</p> */}
            </motion.div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default Modal;
